import { get } from "lodash";
import { useFormStore } from "@/shared/forms";
import { useFieldContext } from "./FieldContext";
import { ExactnessCheckbox, PlaceExactness, YearExactness } from "./field-exactness";
import { FieldComposerExactnessType } from "./types";

export function GenericExactness() {
    const { fieldConfig, fieldPath, exactnessFieldPath } = useFieldContext();
    const fieldValue = useFormStore((v) => get(v.values, fieldPath));

    const exactnessVisible = fieldConfig.showExactness ?? true;

    if (!exactnessVisible || !exactnessFieldPath) return null;

    switch (fieldConfig.exactnessType) {
        case FieldComposerExactnessType.Year:
            return <YearExactness />;
        case FieldComposerExactnessType.Place:
            return <PlaceExactness />;
        default:
            return (
                <ExactnessCheckbox
                    show
                    name={exactnessFieldPath}
                    inputValue={fieldValue as string}
                    dataTestId={exactnessFieldPath as string}
                />
            );
    }
}
